export default "__VITE_ASSET__DymGCJva__"